/* Stylesheet */

.chart_layout_wrapper {
  padding: 24px 0px 24px 0px;
  position: relative;
  margin: 0 auto;
  width: 95%;
}

/* Media Queries */

@media screen and (min-width: 1532px) {
  .chart_layout_wrapper {
    width: 90%;
  }
}
